import { render, staticRenderFns } from "./BarSpinner.vue?vue&type=template&id=4fba9360&scoped=true&"
var script = {}
import style0 from "./BarSpinner.vue?vue&type=style&index=0&id=4fba9360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba9360",
  null
  
)

export default component.exports